/**
 * Content-Disposition ヘッダーからファイル名を取得する
 * @param contentDisposition Content-Disposition ヘッダーの値
 * @param fallback ファイル名が取得できなかった場合のフォールバック
 * @returns ファイル名
 */
export function getFileNameFromContentDisposition(
  contentDisposition: string | null,
  fallback: string,
): string {
  if (!contentDisposition) {
    return fallback
  }

  // filename*=UTF-8''<encoded> 形式を優先して取得
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1].trim())
  }

  // filename="<name>" または filename=<name> 形式を取得
  const match = contentDisposition.match(/filename="?([^";\n]+)"?/i)
  if (match) {
    return match[1].trim()
  }

  return fallback
}

/**
 * Blob をブラウザでダウンロードさせる
 * @param blob ダウンロードする Blob
 * @param fileName ダウンロードファイル名
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
